import { FC } from "react";
import KickImage from 'Reuseables/KickImage';

//Interface
import { DateCardInterface } from "../definitions";

const DateCard: FC<DateCardInterface> = ({
  cardList,
  isActiveCardHandler,
  selectDateHandler
}) => {
  return (
    <>
      <p className="title">Set Pick-up Date</p>
      <div className="pickup-date-wrapper">
        {
          cardList?.length ? cardList.map((card, idx) => {
            const isActive = isActiveCardHandler(card);
            return (
              <div key={idx} className={`date-card ${isActive ? "active" : ""}`} onClick={() => selectDateHandler(card)}>
                <p>{card?.day}, {card?.month} {card?.date[0]}<span>{card?.date[1]}</span></p>
              </div>
            )
          }) : null
        }
      </div>

    </>
  )
}

export default DateCard;